export default {
  login(state, payload) {
    state.loggedIn = payload;

  }
}